<template>
  <van-overlay :show="visible" z-index="99">
    <div
      class="popup ab_center"
    >
      <div class="popup_img bg_contain round_5">
        <img :src="require(`@/assets/clockIn/openup_${isNew ? 'new' : 'old'}.png`)" />
      </div>
      <div
        class="popup_confirm flex_center ab_x_center"
      >
        <van-button
          width="100%"
          color="linear-gradient(#5f59fb 0%, #2e30a1 100%)"
          round
          block
          @click="handleOk"
        >
          <span class="bold">点击领取</span>
        </van-button>
      </div>
    </div>
  </van-overlay>
</template>
<script>
export default {
  props: {
    // 是否是新用户
    isNew: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      visible: false,
    }
  },
  methods: {
    triggerVisible (v) {
      this.visible = v
    },
    handleOk () {
      this.triggerVisible(false)
      this.$emit('ok')
    },
  },
}
</script>
<style lang="scss" scoped>
.popup {
  position: relative;
  width: 100%;
  margin: 0 auto;
  .popup_img {
    width: 100%;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
  .popup_confirm {
    position: absolute;
    width: 200px;
    bottom: 144px;
    left: 50%;
    transform: translateX(calc(-50% + 6px));
  }
}
</style>